import { render, staticRenderFns } from "./PortalDesignerRules.vue?vue&type=template&id=9f750330&"
import script from "./PortalDesignerRules.vue?vue&type=script&lang=js&"
export * from "./PortalDesignerRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f750330')) {
      api.createRecord('9f750330', component.options)
    } else {
      api.reload('9f750330', component.options)
    }
    module.hot.accept("./PortalDesignerRules.vue?vue&type=template&id=9f750330&", function () {
      api.rerender('9f750330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pageDesigner/PortalDesignerRules.vue"
export default component.exports